import { DataViewConfig, ExpandedViewConfig } from '@creditsights/styleguide-web';
import { InitialActionAllower, RouteToCallback } from '@creditsights/styleguide-web/components/DataView';
import { MY_CONTENT_ROUTES, ROUTES } from '../../../Base.constants';
import { DateRenderer, GhostLinkRenderer } from '../../../components/formatters';
import { NotificationMode, RiskProductAlert } from '../../../models/Preference';
import { WatchList } from '../../../models/WatchList';
import { NEW_WATCHLIST_TEMP_ID } from './WatchlistTab.constants';
import WatchlistTitleFormatter from './WatchlistTitleFormatter/WatchlistTitleFormatter';

export const getKey = (watchlist: WatchList): string => watchlist.id;

const expandedViewConfig = (): ExpandedViewConfig => {
  const shouldAllowInitialAction: InitialActionAllower = () => false;
  const routeToCallback: RouteToCallback = (watchListId) =>
    `${ROUTES.myContent}/${MY_CONTENT_ROUTES.watchlists(watchListId)}`;

  return {
    title: {
      dataKey: 'name',
      dataRenderer: WatchlistTitleFormatter,
      dataViewItemConfiguration: { shouldAllowInitialAction, routeToCallback },
    },
    subtitle: [
      {
        renderWithoutDataValue: true,
        dataRenderer: GhostLinkRenderer,
        dataViewItemConfiguration: { shouldAllowInitialAction, routeToCallback },
      },
      {
        dataKey: 'createdAt',
        dataRenderer: DateRenderer,
        dataViewItemConfiguration: {
          shouldAllowInitialAction,
          routeToCallback,
        },
      },
    ],
    contentIndent: true,
  };
};

export const viewConfig: DataViewConfig<WatchList> = {
  expandedViewConfig: expandedViewConfig(),
  clickable: true,
};

export const isNewWatchlist = (id: string): boolean => id.startsWith(NEW_WATCHLIST_TEMP_ID);

export const constructNewEmptyWatchlist = (name: string, currentWatchlistsLength: number): WatchList => ({
  name,
  id: `${NEW_WATCHLIST_TEMP_ID}${currentWatchlistsLength}`,
  tags: [],
  myCS: true,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  mode: NotificationMode.None,
  riskProductAlert: RiskProductAlert.None,
});
